const doc = [({"en":({"js":({"sessions":({"new":({"index":({"sign_in":"Sign in", "create_user":"Create user", "login_with":"Login with"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;